import { List } from 'immutable'
import { UserTypeNumeral } from 'utils/UserTypes'

export function getPresenceUserIds(user) {
  const typeNumeral = UserTypeNumeral[user.type]
  if (user.type === 'LEAD') {
    return List([
      `${user.orgId}-anon:${user.primaryIdentity}-${typeNumeral}`,
      `${user.orgId}-${user.id}-${typeNumeral}`,
    ])
  } else {
    return List.of(`${user.orgId}-${user.id}-${typeNumeral}`)
  }
}

export function flattenMetas(result, { metas }, userId) {
  result[userId] = metas.map(meta => ({ type: "join", meta }))
  return result
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/helpers.js